import React, { useEffect } from 'react';
import { FaFileAlt, FaTrophy } from 'react-icons/fa';
import { Container, Typography } from 'amphitheatre';

const { Header, Paragraph } = Typography;

const Rules: React.FunctionComponent = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container className="content-container" size="lg">
      <Header>
        <FaFileAlt /> Rules & Regulations
      </Header>
      <Paragraph>
        1. Judges will evaluate your submissions based on two criteria:
      </Paragraph>
      <Paragraph>
        <ul>
          <li>
            (70%) The <b>Return on Investment</b> (ROI), but guided by{' '}
            <b>Total Addressable Market</b> (TAM) calculated as a result of the
            constellation, orbit, and customer / products that are reachable
            with your solution.
          </li>
          <li>
            (30%) The <b>viability</b> of the business idea in terms of
            realistic and achievable goals, product-customer fit, and selected
            price points for the product.
          </li>
        </ul>
      </Paragraph>
      <Paragraph>
        <i>
          Note that TAM is quantified from your PIGI output and a PIGI scene
          file is required along with the spreadsheet (see the example provided)
          to show your work. Viability score is evaluated subjectively by the
          judges based on your business concept. Specifically we will look to
          see your assumptions, price points, and concepts are realistically
          achievable, sellable ideas. You can be creative but still be do-able
          without the need for unobtanium or warp drives.
        </i>
      </Paragraph>
      <Paragraph>
        2. This is not a writing competition; however, clarity is essential in
        understanding your business concept. Be brief and to the point with
        clear English. Use the format given in the instructions (see: QFB
        Business Concept Template). An example solution is provided for your
        support (see: QFB Business Concept Example).
      </Paragraph>
      <Paragraph>
        3. Business concepts must be the original work of a single author and{' '}
        <b>not written for paid employment</b>. The business concept may not be
        under review for consideration or publication anywhere at the time it is
        submitted to this competition.
      </Paragraph>
      <Paragraph>
        4. The manuscript must be no more than three (3) pages. Do not submit an
        abstract, endnotes, or table of contents. Forms will be provided and
        must be submitted on the QFB competition website. Any entry longer than
        three pages will be disqualified without review.
      </Paragraph>
      <Paragraph>5. Only one entry per person is allowed.</Paragraph>
      <Paragraph>
        6. The judges reserve the right not to award any prizes and to reject
        any or all submissions. Saber Astronautics reserves the right not to
        select any business plan or award any prizes if, in our judgment, the
        submissions do not meet suitable quality of work.
      </Paragraph>
      <Paragraph>
        7. Required forms must be submitted to the Quest For Blue competition
        website by midnight (AEST) on <b>31 October, 2020</b>. In order to
        identify your entry, use your name as part of the file for your
        submission documents and a descriptive name related to the subject
        matter I.e.,
        <b>“SMITH_James_BizPlan.pdf”</b>, <b>“SMITH_James_PIGI.scene”</b> or
        <b>“SMITH_James_TAMCalcs.csv”</b>. No other files are to be submitted.
      </Paragraph>
      <Paragraph>
        8. Saber Astronautics and P.I.G.I. content such as images, audio, video,
        and computer files are the proprietary intellectual property of Saber
        Astronautics. You may use this material under the terms of the EULA
        software agreement provided with P.I.G.I to produce and communicate your
        own business ideas. When using any Saber Astronautics content in your
        own materials, Saber Astronautics must be acknowledged as the source of
        the material.
      </Paragraph>
      <Header>
        <FaTrophy /> Publication and Prizes
      </Header>
      <Paragraph>
        1. The following prizes are available: First Place: $2,000; Second
        Place: $1,500; Third Place: $1,000; 2 X Notable Works: $250.
      </Paragraph>
      <Paragraph>
        2. Names of the winning individuals may be mentioned on the QFB and
        Saber Astronautics websites and in a press release.
      </Paragraph>
      <Paragraph>
        3. Saber Astronautics may, at its discretion, include a copy of any or
        all of the prize-winning business plans in an issue of its newsletter or
        on its website.
      </Paragraph>
      <Paragraph>
        4. Saber Astronautics will have the final authority, in our sole
        discretion, over whether to publish a winning business concept.
      </Paragraph>
    </Container>
  );
};

export default Rules;
